import { useState } from "react";
import { SectionHead } from "@/components/feature/cards";

const faqs = [
  {
    q: "你们的实时吃瓜内容和别家有什么区别？",
    a: "我们把散落在微博、短视频与社区的瓜料按主题做实时吃瓜合集与盘点整理，用清晰的分类和时间线帮你省去全网来回翻的麻烦。每一条都注明话题方向与热度，只做整理与观察，不做臆测结论。",
  },
  {
    q: "为什么有的文章看起来像“没结论”？",
    a: "因为我们把“吃瓜”当成一件需要讲清楚来龙去脉的事，而不是情绪宣泄。信息未完全明朗的话题，我们会如实标注进展状态并持续蹲后续更新，而不是为了流量替你下结论。",
  },
  {
    q: "蹲后续是什么意思？后续会一直更新吗？",
    a: "“蹲后续”是指持续追踪某个仍在发酵的话题。我们会针对仍有新进展的大瓜建立追更线索，当你通过专题合集进入后，可通过收藏或邮件订阅实时吃瓜周报来第一时间获取更新。",
  },
  {
    q: "文章里的热度数据是怎么来的？",
    a: "热度数据基于各平台讨论量、转发与话题阅读的大致量级整理，仅用于帮助读者判断话题关注度，不代表权威统计。我们不会虚构公司、认证或权威奖项等资质信息。",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section className="border-t border-background-200 bg-background-100/60">
      <div className="container-x py-10 md:py-14">
        <SectionHead kicker="常见问题 · FAQ" title="关于实时吃瓜，你可能想问" />
        <div className="mx-auto max-w-3xl divide-y divide-background-300 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.q}
                  </h3>
                  <span
                    className={
                      "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-sm transition-colors " +
                      (open
                        ? "border-primary-500 bg-primary-500 text-background-50"
                        : "border-background-300 text-foreground-500")
                    }
                  >
                    <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {open ? (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">
                    {item.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}